import {
  EarningsFilterPeriodsResponse,
  EarningsFilterStatsRequest,
  earnings,
} from '@api/api/earnings';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_FILTER_PERIODS = 'QUERY_KEY_EARNINGS_FILTER_PERIODS';

export const useEarningsFilterPeriods = ({
  body,
  enabled = true,
}: {
  body: EarningsFilterStatsRequest;
  enabled?: boolean;
}) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_FILTER_PERIODS, body],
    enabled,
    queryFn: ({ signal }) => {
      const { path, schema } = earnings.postEarningsFilterPeriodsV2;
      return wretchRequest<EarningsFilterPeriodsResponse>(path, {
        method: 'post',
        body,
        schema,
        signal,
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
  });
